/**
 * @Author: JulienBigot7 julien@generation-internet.biz
 * @Date: 2024-10-10 15:02:36
 * @LastEditors: JulienBigot7 julien@generation-internet.biz
 * @LastEditTime: 2024-11-04 11:10:09
 * @FilePath: src/utils/api-utils.ts
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
import { getServerSession } from "next-auth";

import { getBackAPIUrl } from "@/app/api/dynabuy-back/getBackAPIUrl";
import { authConfig } from "@/utils/auth-config";

export const fetchWithNoStore = async (
  url: string | URL,
  options: RequestInit = {},
) => {
  const fetchOptions: RequestInit = {
    ...options,
    cache: "no-store",
  };
  return fetch(url, fetchOptions);
};

export const getFetchUtils = async (): Promise<{
  dynabuyToken: string | undefined;
  backAPIUrl: string | undefined;
}> => {
  const backAPIUrl = await getBackAPIUrl();
  const session = await getServerSession(authConfig);
  return { dynabuyToken: session?.user.dynabuyToken, backAPIUrl };
};
